import { useEffect, useState, useCallback } from "react";
import { getUsersByGroupId } from "../services/userService";

interface IuseFetchUsersByGroupId {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  groupId: string | number | null | undefined;
}

const useFetchUsersByGroupId = ({
  setIsLoading,
  groupId,
}: IuseFetchUsersByGroupId) => {
  const [usersData, setUsersData] = useState<any>([]);

  const fetchUsersData = useCallback(async () => {
    if (!groupId) {
      setUsersData([]);
      return;
    }

    setIsLoading(true);
    try {
      const res = await getUsersByGroupId(groupId);
      console.log("res", res);
      const usersWithId =
        res?.length > 0 &&
        res?.map((user: any, index: number) => ({
          ...user,
          id: user?.user_id || index + 1,
        }));
      console.log("usersWithId", usersWithId);
      setUsersData(usersWithId || []);
    } catch (err) {
      setUsersData([]);
    } finally {
      setIsLoading(false);
    }
  }, [setIsLoading, groupId]);

  useEffect(() => {
    fetchUsersData();
  }, [fetchUsersData]);

  return [usersData, fetchUsersData];
};

export default useFetchUsersByGroupId;
